import { type IContent } from "@kunduz/data-access-cms-api";
import React, { ReactElement } from "react";
import styles from "./detailedAccordion.module.scss";
import { Accordion } from "../accordion";
import { AccordionContentWrapper } from "./accordionContentWrapper";
import { AccordionChildren } from "./accordionChildren";

export const DetailedAccordion = (props: Props): ReactElement => {
  return (
    <section className={styles.base}>
      <div className={styles.wrapper}>
        <div className={styles.left}>
          <div className={styles.sticky}>
            <p className={styles.title}>{props.data.title}</p>
            <div
              className={styles.description}
              dangerouslySetInnerHTML={{ __html: props.data.description }}
            />
          </div>
        </div>
        <div className={styles.right}>
          {props.data.options.map((option, i) => (
            <div
              className={styles.accordionWrapper}
              key={`detailed_accordion_${i}`}
            >
              {option.title && (
                <p className={styles.accordionTitle}>{option.title}</p>
              )}
              <Accordion
                accordionItems={option.items.map((optionItem) => ({
                  title: optionItem.title,
                  children: (
                    <AccordionContentWrapper
                      bgColor={optionItem.bg_color}
                      hasPadding={option.has_padding}
                    >
                      <AccordionChildren
                        accordionItemDesc={optionItem.description}
                        items={optionItem.items}
                      />
                    </AccordionContentWrapper>
                  ),
                  iconUrl: optionItem.icon,
                  onCollapseChanged: props.onCollapseChanged,
                }))}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

interface Props {
  data: IContent.DetailedAccordionData;
  onCollapseChanged?: (title: string) => void;
}
